import React from "react";
import { PAGE } from "../constants/page";
import BreadcrumbService from "../services/BreadcrumbsService";
import "../../src/styles/components/Breadcrumbs.scss";
import {
  breadcrumbRoute,
  resetBreadcrum,
  resetBreadcrumFrom,
} from "../redux/reducers/BreadcrumbSlice";
import { useDispatch } from "react-redux";
import { Trans } from "react-i18next";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";

interface breadcrumbType {
  routes: breadcrumbRoute[];
  navigateTo: any;
}

const Breadcrumb2 = (props: breadcrumbType) => {
  const breadcrumbService = BreadcrumbService.instance;
  const breadcrumbLen = props.routes.length;
  const breadcurmbs = props.routes.slice(0, breadcrumbLen - 1);
  const activeBreadcrumb = props.routes[breadcrumbLen - 1];
  const dispatch = useDispatch();

  const handleHomeClick = (e: any) => {
    dispatch(resetBreadcrum());
    props.navigateTo(PAGE.GLOBAL_HOME);
  };

  const handleBreadcrumbClick = (route: any) => {
    dispatch(resetBreadcrumFrom(route.index));
    props.navigateTo(route.path);
  };

  const handleSearchClick = () => {
    console.log("search clicked");
  };

  return (
    <div className="bg-light-gray">
      {location.pathname === "/introspect" ? null : (
        <div className="container adminBreadCrumbContainer text-capitalize">
          <nav>
            <ol className="breadcrumb breadcrumbAdmin">
              <span className="item" onClick={handleHomeClick}>
                <Trans i18nKey={"home"}></Trans>
              </span>

              {breadcrumbService.advancedSearch !== null && (
                <li className="item" onClick={handleSearchClick}>
                  <Trans i18nKey={"search_result"}></Trans>
                </li>
              )}
              {props.routes &&
                breadcurmbs.length > 0 &&
                breadcurmbs.map((route: any, index: number) => {
                  return (
                    <>
                      <span
                        className="item"
                        key={"item-breadcrumb" + index}
                        onClick={() => handleBreadcrumbClick(route)}
                      >
                        {route?.label_key ? (
                          <Trans i18nKey={route.label_key}></Trans>
                        ) : (
                          route.label
                        )}
                      </span>
                    </>
                  );
                })}

              <li className="item active" aria-current="page">
                <Trans i18nKey={activeBreadcrumb?.label_key}></Trans>
              </li>
            </ol>
          </nav>
        </div>
      )}
    </div>
  );
};

export default ErrorBoundaryHandler(Breadcrumb2);
